import { PageHeader } from '@mogzo/ui';
import type { ReactNode } from 'react';
import { type Crumb, useCrumbs } from '../lib/crumbs';

/**
 * A page outside a project (M25): its header under the top bar, then its content. `crumbs`
 * leads to it; the page's own title ends the breadcrumbs.
 */
export function Page({
  title,
  description,
  actions,
  meta,
  leading,
  tabs,
  crumbs = [],
  crumb,
  wide,
  children,
}: {
  title: string;
  description?: ReactNode;
  actions?: ReactNode;
  meta?: ReactNode;
  leading?: ReactNode;
  tabs?: ReactNode;
  crumbs?: Crumb[];
  /** The last breadcrumb, when it isn't the title. */
  crumb?: string;
  /** Content may use the whole width (wide tables, docs). */
  wide?: boolean;
  children: ReactNode;
}) {
  useCrumbs(...crumbs, { label: crumb ?? title });
  return (
    <>
      <div className="mz-shell-header">
        <div className="mz-shell-header-inner">
          <PageHeader
            title={title}
            description={description}
            actions={actions}
            meta={meta}
            leading={leading}
            tabs={tabs}
          />
        </div>
      </div>
      <main className={`mz-shell-content${wide ? ' mz-shell-content-wide' : ''}`}>{children}</main>
    </>
  );
}
